import { Component, Input, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Filter } from 'app/shared/filter';
import { HttpErrorHandler } from 'app/shared/http-error-handler';

import { EffortItem, EffortFilter } from 'app/_models/effort-item';

@Component({
  selector: 'app-efforts-filter',
  templateUrl: './efforts-filter.component.html',
})
export class EffortsFilterComponent extends Filter implements OnInit {
  @Input() filterParams: any[];
  @Input() loading: Boolean;
  @Output() onApplyFilter = new EventEmitter<string>();

  form: FormGroup;
  filter: EffortFilter;

  years: string[] = [];
  constructor(private fb: FormBuilder, private router: Router, private httpErrorHandler: HttpErrorHandler) {
    super();

    this.years = EffortItem.getYears(2021);

    this.form = fb.group({
      year: [''],
    });
  }

  ngOnInit() {
    this.filter = new EffortFilter(this.filterParams);
  }

  protected onSubmit() {
    this.applyFilter(EffortFilter.serializeRouterParams(this.filter));
  }
  applyFilter(params) {
    this.onApplyFilter.emit(params);
  }
}



// WEBPACK FOOTER //
// ./src/app/efforts/efforts-filter/efforts-filter.component.ts